import { cn } from '@/lib/utils'

interface IProps {
    className?: string
}

export default function VerticalDivider({ className }: IProps) {
    return <div className={cn('w-px self-stretch bg-border', className)} />
}
